import React from "react";
var __jsx = React.createElement;
import { FieldType } from '@uno/common-cms';
import GroupField from 'components/content/GroupField';
import RepeatableField from 'components/content/RepeatableField';
import { EmptyField, FieldContainer } from './FormBuilder.style';
import { AutoGeneratedIdField, CoverImagesField, DateField, ImageField, LinkedContentField, MetaDateField, MetaUrlField, NumberField, ReadOnlyField, RichTextField, SelectField, SimpleTextField, SponsoField, SwitchField, TaxonomyField, VideoField, YTGField } from './fields';
import MetaPublicationDateField from './fields/MetaDataField/MetaPublicationDateField';
var GROUP_ID_FIELD_NAME_SUFFIX = 'GroupId'; // eslint-disable-next-line complexity

var getFieldNode = function getFieldNode(formField, groupLevel) {
  switch (formField.type) {
    case FieldType.SimpleText:
      return __jsx(SimpleTextField, {
        formField: formField
      });

    case FieldType.RichText:
      return __jsx(RichTextField, {
        formField: formField
      });

    case FieldType.Select:
      return __jsx(SelectField, {
        formField: formField
      });

    case FieldType.Switch:
      return __jsx(SwitchField, {
        formField: formField
      });

    case FieldType.Date:
      return __jsx(DateField, {
        formField: formField
      });

    case FieldType.Group:
      return __jsx(React.Fragment, null, __jsx(AutoGeneratedIdField, {
        name: formField.name + GROUP_ID_FIELD_NAME_SUFFIX
      }), __jsx(GroupField, {
        group: formField,
        groupLevel: groupLevel + 1
      }));

    case FieldType.Repeatable:
      return __jsx(RepeatableField, {
        formField: formField
      });

    case FieldType.LinkedContent:
      return __jsx(LinkedContentField, {
        formField: formField
      });

    case FieldType.Taxonomy:
      return __jsx(TaxonomyField, {
        formField: formField
      });

    case FieldType.Image:
      return __jsx(ImageField, {
        formField: formField
      });

    case FieldType.CoverImages:
      return __jsx(CoverImagesField, {
        formField: formField
      });

    case FieldType.Video:
      return __jsx(VideoField, {
        formField: formField
      });

    case FieldType.MetaDate:
      return __jsx(MetaDateField, {
        formField: formField
      });

    case FieldType.MetaPublicationDate:
      return __jsx(MetaPublicationDateField, {
        formField: formField
      });

    case FieldType.MetaUrl:
      return __jsx(MetaUrlField, {
        formField: formField
      });

    case FieldType.ReadOnly:
      return __jsx(ReadOnlyField, {
        formField: formField
      });

    case FieldType.Number:
      return __jsx(NumberField, {
        formField: formField
      });

    case FieldType.SemanticScore:
      return __jsx(YTGField, {
        formField: formField
      });

    case FieldType.Sponso:
      return __jsx(SponsoField, {
        formField: formField
      });

    default:
      return __jsx(EmptyField, null);
  }
};

var FormBuilder = function FormBuilder(_ref) {
  var formFields = _ref.formFields,
      _ref$groupLevel = _ref.groupLevel,
      groupLevel = _ref$groupLevel === void 0 ? 0 : _ref$groupLevel;
  return __jsx(React.Fragment, null, formFields.map(function (formField) {
    var _formField$key;

    return __jsx(FieldContainer, {
      key: (_formField$key = formField.key) !== null && _formField$key !== void 0 ? _formField$key : formField.name
    }, getFieldNode(formField, groupLevel));
  }));
};

export default FormBuilder;